const ShopInfo = ({ className, title, description, link }) => {
  return (
    <div className={` flex flex-col gap-3 md:gap-5 ${className}`}>
      <h5 className="font-bold text-xl md:text-2xl">{title}</h5>
      <p>{description}</p>
      <div className="mt-2 md:mt-4">
        <a
          href={`${link}`}
          className="text-xs px-5 py-3 bg-[#D9D9D9] rounded-full"
          // target="__blank"
        >
          Shop Now
        </a>
      </div>
    </div>
  );
};

export default ShopInfo;
